import { SdfCheckbox } from '@waypoint/react-components';
import React, { useCallback } from 'react';
import { BaseField } from './BaseField';
import { Field } from './types';

/**
 * Single option field component using checkbox
 * @param props - Field component props
 * @param props.id - Unique field identifier
 * @param props.data - Field configuration with single option
 * @param props.onChange - Callback function for value changes
 * @returns JSX element for single option field
 */
export function SingleOption({ id, data, onChange }: Field) {
  const handleChange = useCallback(
    (event: any) => {
      onChange(event?.detail);
    },
    [onChange]
  );

  return (
    <BaseField>
      <SdfCheckbox
        label={data.label}
        id={id}
        checked={data.value}
        onSdfChange={handleChange}
      />
    </BaseField>
  );
}
